var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Mensagem original: \""+_vm._s(_vm.message)+"\"")]),_c('p',[_vm._v("Mensagem ao contrário: \""+_vm._s(_vm.reversedMessage)+"\"")])])}
var staticRenderFns = []

export { render, staticRenderFns }